// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classnames = require('classnames');
const { Link } = require('react-router-dom');

// @ commons
const { formatText } = require('core/i18n').i18n;
const { findIndex, find, every, each, get, reduce, compact } = require('lodash');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { OKLink } = require('commonsComponents/OKLink');
const OKStatusIcon = require('components/commons/OKStatusIcon/OKStatusIcon');

// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const { DOCUMENTS_STATUS, ESTATES_TYPE } = require('constants/mortgageRequestHolderData');
const { MORTGAGE_SIMPLE_NOTE_ISSUE, MORTGAGE_SIMPLE_NOTE_RESULT } = require('constants/links');
const documentsTypes = require('constants/mortgageRequestDocumentsTypes');

class MortgageRequestManagerPanelLivingPlace extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false,
            id: 'stepLivingPlace'
        };

        this.currentState = '';
        this.selectedDate;
        this.handleOnClickAccordion = this.handleOnClickAccordion.bind(this);
        this.buildStatusStep = this.buildStatusStep.bind(this);
    }

    componentWillMount() {
        const { isExpandedLivingPlace } = this.props;
        this.setState({ isExpanded: isExpandedLivingPlace });
    }

    getDocument(documentsTypeList) {
        const documentationList = this.props.summaryDocumentation.get('data', []);
        const documentationListParse = documentationList.toJS();
        let documentData;
        let documentDataStatus;
        for (let i = 0; documentsTypeList[i]; i++) {
            documentData = find(
                documentationListParse,
                doc => doc.tipoDocumentoId === documentsTypeList[i]
            );
            documentDataStatus =
                get(documentData, 'estado', DOCUMENTS_STATUS.NONE) || DOCUMENTS_STATUS.NONE;

            if (
                documentDataStatus !== DOCUMENTS_STATUS.PEND_APORTAR &&
                documentDataStatus !== DOCUMENTS_STATUS.NONE
            ) {
                break;
            }
        }
        return documentDataStatus;
    }

    getSimpleNote() {
        const documentationList = this.props.summaryDocumentation.get('data', []);
        const estatesStateDataList = this.props.estatesStateData.get('dataPanel', []);
        const documentationListParse = documentationList.toJS();
        const estatesStateDataListParse = estatesStateDataList.toJS();
        const listNSTypes = [ESTATES_TYPE.VIVIENDA, ESTATES_TYPE.GARAJE, ESTATES_TYPE.TRASTERO];
        let simpleNote = {};
        let generalStatus = DOCUMENTS_STATUS.NONE;

        each(listNSTypes, NSType => {
            const idListType = get(estatesStateDataListParse, NSType, []);
            if (idListType.length) {
                const documentsFilterBienIds = idListType.map(id => {
                    let itemFound = reduce(
                        documentationListParse,
                        (result, obj) => {
                            if (
                                obj.bienId === id &&
                                ((obj.tipoDocumentoId === documentsTypes.NS &&
                                    obj.estado !== DOCUMENTS_STATUS.PEND_APORTAR) ||
                                    obj.tipoDocumentoId === documentsTypes.NS_CLI)
                            ) {
                                result.push(obj);
                            }
                            return result;
                        },
                        []
                    );

                    if (!itemFound.length) {
                        return DOCUMENTS_STATUS.NONE;
                    } else if (itemFound.length === 1) {
                        return itemFound[0].estado;
                    } else {
                        const documentNS = find(itemFound, { tipoDocumentoId: 'NS' });
                        return documentNS.estado;
                    }
                });

                const documentsStatus = this.getStatusArray(documentsFilterBienIds);
                simpleNote[NSType] = documentsStatus;

                if (
                    NSType !== ESTATES_TYPE.VIVIENDA &&
                    (
                        simpleNote[ESTATES_TYPE.VIVIENDA] !== DOCUMENTS_STATUS.NONE &&
                        simpleNote[ESTATES_TYPE.VIVIENDA] !== DOCUMENTS_STATUS.PEND_APORTAR
                    ) &&
                    (
                        documentsStatus === DOCUMENTS_STATUS.NONE ||
                        documentsStatus === DOCUMENTS_STATUS.PEND_APORTAR
                    )
                ) {
                    simpleNote[NSType] = simpleNote[ESTATES_TYPE.VIVIENDA];
                }
            }
        });
        const estatesStatus = compact([
            simpleNote[ESTATES_TYPE.VIVIENDA],
            simpleNote[ESTATES_TYPE.GARAJE],
            simpleNote[ESTATES_TYPE.TRASTERO]
        ]);

        generalStatus = this.getStatusArray(estatesStatus);
        return generalStatus;
    }

    getStatusArray(statusList) {
        if (statusList.length && every(statusList, val => val === DOCUMENTS_STATUS.VERIFICADO)) {
            return DOCUMENTS_STATUS.VERIFICADO;
        } else if (findIndex(statusList, val => val === DOCUMENTS_STATUS.NO_VALIDO) !== -1) {
            return DOCUMENTS_STATUS.NO_VALIDO;
        } else if (findIndex(statusList, val => {
            return val === DOCUMENTS_STATUS.NONE || val === DOCUMENTS_STATUS.PEND_APORTAR
        }) !== -1) {
            return DOCUMENTS_STATUS.PEND_APORTAR;
        } else if (findIndex(statusList, val => val === DOCUMENTS_STATUS.PEND_VAL) !== -1) {
            return DOCUMENTS_STATUS.PEND_VAL;
        } else {
            return DOCUMENTS_STATUS.NONE;
        }
    }

    buildSimpleNoteLink() {
        const { mortgageRequestState } = this.props;
        const expendienteState = mortgageRequestState.get('estado');
        if (expendienteState === DOCUMENTS_STATUS.PROBLEMA_NS) {
            return MORTGAGE_SIMPLE_NOTE_ISSUE
        } else {
            return MORTGAGE_SIMPLE_NOTE_RESULT
        }
    }

    buildStatusStep(classNameValue) {
        const { isApprovedLivingPlace } = this.props;
        let elementStatus = (
            <span className="mortgage-request-manager-panel-steps__ico--step-approved" />
        );

        if (isApprovedLivingPlace) elementStatus = <h2 className={classNameValue}>2</h2>;
        return elementStatus;
    }

    handleOnClickAccordion() {
        if (this.state.isExpanded) this.setState({ isExpanded: false });
        else this.setState({ isExpanded: true });
    }

    render() {
        const {
            mortgageRequestState,
            summaryDocumentation,
            isExpandedLivingPlace
        } = this.props;
        const tasacionTypeList = [documentsTypes.TAS, documentsTypes.TAS_CLI];
        const isTasacion = this.getDocument(tasacionTypeList);
        const simpleNoteStatus = this.getSimpleNote();
        const expendienteState = mortgageRequestState.get('estado');
        const itemActive = classnames('step-item-num', {
            'step-item-num--active': this.state.isExpanded
        });

        const appraisalIcon = OKStatusIcon({ status: isTasacion });
        const simpleNoteIcon = OKStatusIcon({
            status: simpleNoteStatus,
            error: expendienteState === DOCUMENTS_STATUS.PROBLEMA_NS
        });

        const getStatusStep = this.buildStatusStep(itemActive);

        const isFetchingSummaryDocumentation = summaryDocumentation.get('isFetching');
        if (isFetchingSummaryDocumentation && isExpandedLivingPlace) {
            return (
                <div className="row step-item">
                    <LoadingSection />
                </div>
            );
        }

        return (
            <div className="row step-item">
                <div className="col-xs-1">
                    {getStatusStep}
                </div>
                <div className="col-xs-11">
                    <Accordion
                        customClassName="mortgage-request-manager-panel-steps__collapsable"
                        isExpanded={isExpandedLivingPlace}
                        id={this.state.id}
                        onClick={this.handleOnClickAccordion}
                    >
                        <AccordionHeader
                            name="AccordionHeader"
                            isRightArrowPosition={true}
                        >
                            <h3>{formatText('mortgageRequestPanel-accordionLivingPlaceTitle')}</h3>
                            <p>{formatText('mortgageRequestPanel-livingPlaceDescription')}</p>
                        </AccordionHeader>

                        <AccordionBody name="AccordionBody">
                            <div>
                                <ul className="list-unstyled mortgage-request-manager-panel-steps__list">
                                    <li>
                                        <div className="row">
                                            <div className="col-xs-7">
                                                <p>
                                                    {formatText(
                                                        'mortgageRequestPanel-livingPlaceMortgageRealState'
                                                    )}
                                                </p>
                                            </div>
                                            <OKLink modifier="emphasize" to="/myprofile/mortgage/estates">
                                                <i className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente" />
                                            </OKLink>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="row">
                                            <div className="col-xs-7">
                                                <p>
                                                    {formatText(
                                                        'mortgageRequestPanel-livingPlaceHolderVerification'
                                                    )}
                                                </p>
                                            </div>
                                            <div className="col-xs-1">
                                                {simpleNoteIcon}
                                            </div>
                                            <div className="col-xs-4">
                                                <p className="descripcion">
                                                    {formatText(
                                                        'mortgageRequestPanel-livingPlaceSimpleNote'
                                                    )}
                                                </p>
                                            </div>
                                            <Link
                                                to={this.buildSimpleNoteLink()}
                                            >
                                                <i className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente" />
                                            </Link>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="row">
                                            <div className="col-xs-7">
                                                <p>
                                                    {formatText(
                                                        'mortgageRequestPanel-livingPlaceAppraisal'
                                                    )}
                                                </p>
                                            </div>
                                            <div className="col-xs-1">
                                                {appraisalIcon}
                                            </div>
                                            <div className="col-xs-4">
                                                <p className="descripcion">
                                                    {formatText(
                                                        'mortgageRequestPanel-livingPlaceAppraisalSchedule'
                                                    )}
                                                </p>
                                            </div>
                                            <Link
                                                to="/myprofile/mortgage/property-value-defined"
                                            >
                                                <i className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente" />
                                            </Link>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </AccordionBody>
                    </Accordion>
                </div>
            </div>
        );
    }
}

MortgageRequestManagerPanelLivingPlace.propTypes = {
    isExpandedLivingPlace: PropTypes.bool,
    isApprovedLivingPlace: PropTypes.bool,
    mortgageRequestState: PropTypes.object,
    summaryDocumentation: PropTypes.object,
    estatesStateData: PropTypes.object
};

module.exports.constructor = MortgageRequestManagerPanelLivingPlace;
module.exports.MortgageRequestManagerPanelLivingPlace = connect(
    state => ({
        mortgageRequestState: state.mortgageRequestState,
        summaryDocumentation: state.mortgageRequestSummaryDocumentation,
        estatesStateData: state.mortgageRequestEstatesData
    }),
    null
)(MortgageRequestManagerPanelLivingPlace);
